module.exports = __webpack_public_path__ + "img/报名未通过.a24a96ed.png";